import { resolvePath } from '../../../binding/operators/resolvePath';
import { isSupportedDateInput, toDayString } from '../../../util/datetime';
function evaluateEqualsPathWithTimezone(raw, other, formatWithTimezone, namespaces, loopItem) {
  const timezone = resolvePath(formatWithTimezone, namespaces, loopItem);
  if (typeof timezone !== 'string') return false;
  if (!isSupportedDateInput(raw)) return false;
  const dayString = toDayString(raw, timezone);
  return dayString !== undefined && dayString === String(other);
}
function coerceForComparison(raw, reference) {
  if (typeof raw !== 'string') return raw;
  if (typeof reference === 'boolean') {
    if (raw === 'true') return true;
    if (raw === 'false') return false;
  }
  if (typeof reference === 'number') {
    const parsed = Number(raw);
    if (!Number.isNaN(parsed)) return parsed;
  }
  return raw;
}
function toComparableNumber(raw) {
  if (typeof raw === 'number') return raw;
  if (typeof raw === 'string') {
    const parsed = Number(raw);
    return Number.isNaN(parsed) ? NaN : parsed;
  }
  return NaN;
}
export function isTruthyContextValue(raw) {
  if (raw === 'false') return false;
  return Boolean(raw);
}
export function evaluateCondition(condition, namespaces, loopItem) {
  if ('and' in condition) {
    return condition.and.every(c => evaluateCondition(c, namespaces, loopItem));
  }
  if ('or' in condition) {
    return condition.or.some(c => evaluateCondition(c, namespaces, loopItem));
  }
  if ('not' in condition) {
    return !evaluateCondition(condition.not, namespaces, loopItem);
  }
  const raw = resolvePath(condition.path, namespaces, loopItem);
  if (raw === undefined) return false;
  if ('equals' in condition) {
    const coerced = coerceForComparison(raw, condition.equals);
    return coerced === condition.equals;
  }
  if ('notEquals' in condition) {
    const coerced = coerceForComparison(raw, condition.notEquals);
    return coerced !== condition.notEquals;
  }
  if ('equalsPath' in condition) {
    const other = resolvePath(condition.equalsPath, namespaces, loopItem);
    if (other === undefined) return false;
    if (condition.formatWithTimezone) {
      return evaluateEqualsPathWithTimezone(raw, other, condition.formatWithTimezone, namespaces, loopItem);
    }
    return String(raw) === String(other);
  }
  if ('greaterThan' in condition) {
    const num = toComparableNumber(raw);
    const isNumeric = !Number.isNaN(num);
    return isNumeric && num > condition.greaterThan;
  }
  if ('lessThan' in condition) {
    const num = toComparableNumber(raw);
    const isNumeric = !Number.isNaN(num);
    return isNumeric && num < condition.lessThan;
  }
  return isTruthyContextValue(raw);
}